import {Params} from '../getConfig'

export const amplifyHotelixStaging: Params = {
  aws_user_pools_id: 'eu-west-1_8RsCs15UQ',
  aws_cognito_identity_pool_id: '', // Not needed for any partner
  aws_user_pools_web_client_id: '1sb8sqk8qvml1m6f32nlegtm5v',
  oauth_domain: 'hotelix-auth-staging.auth.eu-west-1.amazoncognito.com',
  aws_user_files_s3_bucket: '' // Not needed for any partner
}
